export default "__VITE_ASSET__Jt5I4Ej3__"